import { Controller, useFormContext } from "react-hook-form";
import { TextInput } from "@luna-restaurant/ui";
export function FormTextInput({ name, label, type = "text", ...inputProps }) {
    const { control } = useFormContext();
    return (<Controller control={control} name={name} render={({ field: { onChange, onBlur, value }, fieldState }) => (<TextInput value={value} placeholder={label} type={type} onChangeText={onChange} onBlur={onBlur} error={fieldState.error?.message ?? false} {...inputProps}/>)}/>);
}
//# sourceMappingURL=FormTextInput.js.map